<template>
  <!-- Профили -->
  <Fieldset v-if="props.profiles.length > 1" :legend="$t('modal.createSwapOrders.profiles')">
    <div class="grid grid-cols-3 sm:grid-cols-6 md:grid-cols-8 lg:grid-cols-10 gap-1">
      <Button @click="props.toggleProfile(idx)" severity="success"
        :variant="props.enabledProfiles.includes(idx) ? undefined : 'outlined'" size="small" fluid
        v-for="idx in props.profiles" :key="idx">
        <i class="pi"
          :class="{ 'pi-check-square': props.enabledProfiles.includes(idx), 'pi-stop': !props.enabledProfiles.includes(idx) }"></i>
        <span>#{{ idx + 1 }}</span>
      </Button>
    </div>
  </Fieldset>
</template>

<script lang="ts" setup>
import Fieldset from 'primevue/fieldset';
import Button from 'primevue/button';

const props = defineProps<{
  profiles: number[]
  enabledProfiles: number[]
  toggleProfile: (arg0: number) => void
}>()
</script>
